// extracted by mini-css-extract-plugin
export default {"header":"styles_header__KQtqi","video":"styles_video__nwJLS","iLogo":"styles_iLogo__DRhiG"};